import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRocket = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Group_3701",
	"data-name": "Group 3701",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 379.953,
	height: 347.103,
	viewBox: "0 0 379.953 347.103",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_3684",
		"data-name": "Group 3684",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Group_3683",
			"data-name": "Group 3683",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_3682",
				"data-name": "Group 3682",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_3672",
						"data-name": "Group 3672",
						transform: "translate(0 326.12)",
						opacity: .5,
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_3671",
							"data-name": "Group 3671",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_3670",
								"data-name": "Group 3670",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_490",
									"data-name": "Path 490",
									d: "M379.953,415.126c0,5.794-85.055,10.492-189.976,10.492S0,420.92,0,415.126s85.055-10.492,189.977-10.492,189.976,4.7,189.976,10.492",
									transform: "translate(0 -404.634)",
									fill: "#d8e9ff"
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_3675",
						"data-name": "Group 3675",
						transform: "translate(40.228 50.761)",
						opacity: .5,
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_3674",
							"data-name": "Group 3674",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_3673",
								"data-name": "Group 3673",
								clipPath: "url(#clip-path-4)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_491",
									"data-name": "Path 491",
									d: "M147.159,65.815c57.331-10.2,103.2,8.56,121.027,33.755s48.225,9.076,73.553,42.236,26.17,115-93.706,120.932-180.7-11.356-193.406-47.722-5.252-131.8,92.532-149.2",
									transform: "translate(-49.912 -62.982)",
									fill: "#d8e9ff"
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_492",
						"data-name": "Path 492",
						d: "M149.143,93.974s18.249,46.7,93.405,53.679,100.8-17.892,127.01-10.635",
						transform: "translate(-28.94 -18.235)",
						fill: "none",
						stroke: "#2cd5c4",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1,
						strokeDasharray: "5 5"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_3678",
						"data-name": "Group 3678",
						transform: "translate(79.371 36.546)",
						opacity: .47,
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_3677",
							"data-name": "Group 3677",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_3676",
								"data-name": "Group 3676",
								clipPath: "url(#clip-path-5)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_493",
									"data-name": "Path 493",
									d: "M118.59,86.046l11.9-17.053,16.57-4.987L98.48,45.345Z",
									transform: "translate(-98.481 -45.345)",
									fill: "#2cd5c4"
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_494",
						"data-name": "Path 494",
						d: "M98.481,45.345,129,71.138l3.428,8.231,1.5-11.408Z",
						transform: "translate(-19.109 -8.799)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_495",
						"data-name": "Path 495",
						d: "M132.15,82.19l6.808,3.39-3.428-8.231Z",
						transform: "translate(-25.642 -15.009)",
						fill: "#22bcaa"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_497",
						"data-name": "Path 497",
						d: "M213.194,24.686a13.272,13.272,0,1,1-13.272-13.272,13.272,13.272,0,0,1,13.272,13.272",
						transform: "translate(-36.218 -2.215)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_498",
						"data-name": "Path 498",
						d: "M206.168,30.661a4.928,4.928,0,0,1-2.785,1.421v1.973h-2.954V32.144a7.446,7.446,0,0,1-3.946-1.489l.893-2.01a5.173,5.173,0,0,0,.981.676,7.1,7.1,0,0,0,1.452.6,5.845,5.845,0,0,0,1.663.242,3.122,3.122,0,0,0,1.743-.465,1.627,1.627,0,0,0,.714-1.47,1.236,1.236,0,0,0-.416-.944,3.3,3.3,0,0,0-1.012-.626,15.777,15.777,0,0,0-1.551-.515,10.826,10.826,0,0,1-2.234-.894,4.374,4.374,0,0,1-1.539-1.408,3.887,3.887,0,0,1-.6-2.216,3.719,3.719,0,0,1,.453-1.817,3.945,3.945,0,0,1,1.315-1.4,5.4,5.4,0,0,1,2.079-.781V15.218h2.954v2.419a6.668,6.668,0,0,1,1.842.608,3.419,3.419,0,0,1,1.111.82l-.993,1.911a2.624,2.624,0,0,0-.645-.515,5.837,5.837,0,0,0-1.173-.559,4.017,4.017,0,0,0-1.359-.243,3.2,3.2,0,0,0-1.768.459,1.485,1.485,0,0,0-.714,1.328,1.569,1.569,0,0,0,.807,1.421,6.743,6.743,0,0,0,2.023.763,7.857,7.857,0,0,1,3.369,1.589,3.473,3.473,0,0,1,1.3,2.755,3.794,3.794,0,0,1-1.012,2.686",
						transform: "translate(-38.125 -2.953)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_499",
						"data-name": "Path 499",
						d: "M108.508,238.063h-7.081a3.713,3.713,0,0,1-3.713-3.713v-6.822h14.507v6.822a3.713,3.713,0,0,1-3.713,3.713",
						transform: "translate(-18.96 -44.149)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_500",
						"data-name": "Path 500",
						d: "M122.364,193.567a20.553,20.553,0,0,1-5.529,14.04,20.957,20.957,0,0,1-2.821,2.523,9.244,9.244,0,0,1-9.236,9.228H98.387a9.249,9.249,0,0,1-9.244-9.244v-.25a20.611,20.611,0,1,1,33.222-16.3",
						transform: "translate(-15.744 -33.559)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_501",
						"data-name": "Path 501",
						d: "M118.166,213.194a20.956,20.956,0,0,1-2.821,2.523,9.244,9.244,0,0,1-9.236,9.228H99.718a9.249,9.249,0,0,1-9.244-9.244v-.25A20.494,20.494,0,0,1,88,213.194a15.659,15.659,0,0,1,30.167,0",
						transform: "translate(-17.075 -39.146)",
						fill: "#90b9d6"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_502",
						"data-name": "Path 502",
						d: "M113.011,197.66h-1.149a7.149,7.149,0,0,1-6.571,7.116v-7.117a.574.574,0,0,0-1.148,0v7.117a7.151,7.151,0,0,1-6.571-7.116H96.424a8.3,8.3,0,0,0,7.719,8.264v16.955a.574.574,0,0,0,1.148,0V205.924a8.3,8.3,0,0,0,7.72-8.264",
						transform: "translate(-18.71 -38.242)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_503",
						"data-name": "Path 503",
						d: "M110.979,177.047a15.881,15.881,0,0,1,10.794,7.944",
						transform: "translate(-21.534 -34.354)",
						fill: "none",
						stroke: "#fff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 3
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_447",
						"data-name": "Line 447",
						x2: .388,
						y2: .95,
						transform: "translate(101.702 153.95)",
						fill: "none",
						stroke: "#fff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 3
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_3681",
						"data-name": "Group 3681",
						transform: "translate(297.52 52.96)",
						opacity: .48,
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_3680",
							"data-name": "Group 3680",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_3679",
								"data-name": "Group 3679",
								clipPath: "url(#clip-path-6)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_504",
									"data-name": "Path 504",
									d: "M412.247,91.43V83.768L406.475,82.6a16,16,0,0,0-.724-1.831l3.678-4.717-5.007-5.8-5.509,3.1a16.167,16.167,0,0,0-2.861-1.26l-1.27-6.389H387.12L385.832,72.1a16.2,16.2,0,0,0-2.737,1.183l-6.121-3.45-5.007,5.8,4.1,5.262c-.169.375-.319.758-.459,1.147l-6.461,1.3v7.662L375.3,92.23a16.241,16.241,0,0,0,.721,1.954l-4.3,5.511,5.007,5.8,6.375-3.592a16.42,16.42,0,0,0,1.814.842l1.45,7.295h7.662l1.365-6.768a16.147,16.147,0,0,0,2.452-.92l6.329,3.567,5.007-5.8-3.827-4.907a16.163,16.163,0,0,0,1.111-2.632ZM390.94,95.91a8.322,8.322,0,1,1,8.322-8.322,8.322,8.322,0,0,1-8.322,8.322",
									transform: "translate(-369.15 -65.711)",
									fill: "#b6d5ef"
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Ellipse_109",
						"data-name": "Ellipse 109",
						cx: 12.608,
						cy: 12.608,
						r: 12.608,
						transform: "translate(302.596 68.301) rotate(-22.5)",
						fill: "none",
						stroke: "#fff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_505",
						"data-name": "Path 505",
						d: "M259.767,21.929H256.2v-3.57a.4.4,0,1,0-.806,0v3.57h-3.569a.4.4,0,1,0,0,.806h3.569V26.3a.4.4,0,1,0,.806,0v-3.57h3.57a.4.4,0,0,0,0-.806",
						transform: "translate(-48.785 -3.484)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_506",
						"data-name": "Path 506",
						d: "M38.514,192.342h-3.57v-3.57a.4.4,0,1,0-.806,0v3.57H30.57a.4.4,0,1,0,0,.806h3.569v3.57a.4.4,0,0,0,.806,0v-3.57h3.57a.4.4,0,1,0,0-.806",
						transform: "translate(-5.854 -36.551)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_507",
						"data-name": "Path 507",
						d: "M399.105,180.519h-3.57v-3.57a.4.4,0,1,0-.806,0v3.57h-3.569a.4.4,0,0,0,0,.806h3.569v3.57a.4.4,0,0,0,.806,0v-3.57h3.57a.4.4,0,1,0,0-.806",
						transform: "translate(-75.823 -34.257)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_508",
						"data-name": "Path 508",
						d: "M196.465,95.528a2.674,2.674,0,1,1-2.674-2.674,2.675,2.675,0,0,1,2.674,2.674",
						transform: "translate(-37.084 -18.017)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_509",
						"data-name": "Path 509",
						d: "M147.468,251.563a2.674,2.674,0,1,1-2.674-2.674,2.674,2.674,0,0,1,2.674,2.674",
						transform: "translate(-27.577 -48.294)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_512",
						"data-name": "Path 512",
						d: "M155.318,275.4l-27.009,18.66-11.786,62.857h9.33l14.978-49.844,16.205-4.665Z",
						transform: "translate(-22.61 -53.438)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_513",
						"data-name": "Path 513",
						d: "M293.671,275.4l27.009,18.66,11.786,62.857h-9.33l-14.978-49.844-16.206-4.665Z",
						transform: "translate(-56.65 -53.438)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_514",
						"data-name": "Path 514",
						d: "M223.792,309.4h-50.43l5.3,30.165h80.711l5.3-30.165Z",
						transform: "translate(-33.639 -60.035)",
						fill: "#2d2e83"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_515",
						"data-name": "Path 515",
						d: "M187.163,337.966h0a3.372,3.372,0,0,1-3.372-3.372V322.341a3.372,3.372,0,1,1,6.744,0v12.253a3.372,3.372,0,0,1-3.372,3.372",
						transform: "translate(-35.663 -61.892)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_516",
						"data-name": "Path 516",
						d: "M204.175,337.966h0a3.372,3.372,0,0,1-3.372-3.372V322.341a3.372,3.372,0,1,1,6.744,0v12.253a3.372,3.372,0,0,1-3.372,3.372",
						transform: "translate(-38.964 -61.892)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_517",
						"data-name": "Path 517",
						d: "M221.187,337.966h0a3.372,3.372,0,0,1-3.372-3.372V322.341a3.372,3.372,0,1,1,6.744,0v12.253a3.372,3.372,0,0,1-3.372,3.372",
						transform: "translate(-42.265 -61.892)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_518",
						"data-name": "Path 518",
						d: "M238.2,337.966h0a3.372,3.372,0,0,1-3.372-3.372V322.341a3.372,3.372,0,1,1,6.744,0v12.253a3.372,3.372,0,0,1-3.372,3.372",
						transform: "translate(-45.565 -61.892)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_519",
						"data-name": "Path 519",
						d: "M255.21,337.966h0a3.372,3.372,0,0,1-3.372-3.372V322.341a3.372,3.372,0,1,1,6.744,0v12.253a3.372,3.372,0,0,1-3.372,3.372",
						transform: "translate(-48.867 -61.892)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_520",
						"data-name": "Path 520",
						d: "M272.222,337.966h0a3.372,3.372,0,0,1-3.372-3.372V322.341a3.372,3.372,0,1,1,6.744,0v12.253a3.372,3.372,0,0,1-3.372,3.372",
						transform: "translate(-52.167 -61.892)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_521",
						"data-name": "Path 521",
						d: "M270.746,241.027H160.217s-.21-64.525,16.353-113.439v-.008c1.04-3.063,2.144-6.069,3.313-8.986,3.288-.588,7.238-1.161,11.864-1.6,5.472-.532,11.88-.887,19.254-.9.943,0,1.894.008,2.869.016,5.4.056,10.477.258,15.184.564,4.8.306,9.22.709,13.194,1.153,3.321.379,6.335.782,9,1.177.121.3.242.6.363.927.185.475.379.983.58,1.507.258.693.524,1.4.782,2.112s.508,1.427.75,2.1c.177.508.347,1,.508,1.459,16.724,48.97,16.514,113.923,16.514,113.923",
						transform: "translate(-31.088 -22.525)",
						fill: "#5353cd"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_522",
						"data-name": "Path 522",
						d: "M265.718,271.107a358.135,358.135,0,0,1-4.425,39.492H191.747c-3.167-7.721-7.294-20.689-9.51-39.492H224.59c.395,13.645.467,26.806.032,38.573h20.455s.3-16.119.032-38.573Z",
						transform: "translate(-35.361 -52.605)",
						fill: "#a67cf4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_523",
						"data-name": "Path 523",
						d: "M253.353,243.7h-20.52c-1.225-42.659-5.666-89.977-8.116-113.7,6.754-.048,13.645-.089,19.835-.129,6.536,28.66,8.366,78.912,8.8,113.834",
						transform: "translate(-43.604 -25.199)",
						fill: "#7373df"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_524",
						"data-name": "Path 524",
						d: "M247.747,166.036c0,15.007-12.558,27.173-28.05,27.173s-28.051-12.166-28.051-27.173,12.559-27.173,28.051-27.173,28.05,12.166,28.05,27.173",
						transform: "translate(-37.187 -26.945)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_525",
						"data-name": "Path 525",
						d: "M248.658,162.527a26.122,26.122,0,0,1-1,7.189,25.445,25.445,0,0,1-1.975,4.924,26.159,26.159,0,1,1-34.954-35.495.008.008,0,0,1,.008-.008,26.179,26.179,0,0,1,37.92,23.389",
						transform: "translate(-38.095 -26.459)",
						fill: "#a67cf4"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_1202",
						"data-name": "Rectangle 1202",
						width: 212.33,
						height: 13.933,
						transform: "translate(77.531 303.476)",
						fill: "#c6c4f5"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_1203",
						"data-name": "Rectangle 1203",
						width: 239.025,
						height: 13.933,
						transform: "translate(61.89 317.41)",
						fill: "#5a61a8"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_526",
						"data-name": "Path 526",
						d: "M217.972,116.087c.29,2.627.709,6.456,1.2,11.235-8.406.056-16.619.113-23.026.169.967-4.086,1.846-7.64,2.571-10.5,5.472-.532,11.88-.887,19.254-.9",
						transform: "translate(-38.06 -22.525)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_527",
						"data-name": "Path 527",
						d: "M261.746,127.26c-3.643.016-8.164.04-13.137.073a92.826,92.826,0,0,0-2.982-10.526c4.8.306,9.22.709,13.194,1.153.6,1.805,1.628,4.981,2.926,9.3",
						transform: "translate(-47.661 -22.665)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_528",
						"data-name": "Path 528",
						d: "M187.475,310.6H160.217V271.107h17.747c2.216,18.8,6.343,31.771,9.51,39.492",
						transform: "translate(-31.088 -52.605)",
						fill: "#8b6adf"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_529",
						"data-name": "Path 529",
						d: "M195.683,117.207c-.725,2.861-1.6,6.415-2.571,10.5-7.544.056-12.605.1-12.605.1V127.8c1.04-3.063,2.144-6.069,3.313-8.986,1.128-.2,2.337-.4,3.627-.6.258-.04.524-.073.782-.113,2.257-.33,4.739-.637,7.455-.895",
						transform: "translate(-35.025 -22.743)",
						fill: "#90b9d6"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_530",
						"data-name": "Path 530",
						d: "M176.57,225.582c.25,6.585.733,12.637,1.394,18.191H160.217s-.21-64.525,16.353-113.439c0,0,5.061-.04,12.605-.1-5.5,23.381-13.774,64.356-12.605,95.345",
						transform: "translate(-31.088 -25.271)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_531",
						"data-name": "Path 531",
						d: "M294.052,271.107V310.6H280.327a358.128,358.128,0,0,0,4.425-39.492Z",
						transform: "translate(-54.394 -52.605)",
						fill: "#b498fa"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_532",
						"data-name": "Path 532",
						d: "M273.982,127.522c-.081-.024-3.586-.016-9.059.016-1.3-4.32-2.329-7.5-2.926-9.3,3.32.379,6.335.782,9,1.177.121.3.242.6.363.927.185.476.379.983.58,1.507.258.693.524,1.4.782,2.112s.508,1.427.75,2.1c.177.508.347,1,.508,1.459",
						transform: "translate(-50.838 -22.943)",
						fill: "#daebf7"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_533",
						"data-name": "Path 533",
						d: "M291.2,243.676h-9.3c.806-14.6.709-31.021-1.515-46.786a467.854,467.854,0,0,0-14.757-67.12c5.472-.032,8.978-.04,9.059-.016C291.41,178.724,291.2,243.676,291.2,243.676",
						transform: "translate(-51.542 -25.175)",
						fill: "#7373df"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_534",
						"data-name": "Path 534",
						d: "M245.684,176.627a26.164,26.164,0,1,1-42.256-30.03c.669,1.08,1.975,3.111,3.844,5.618A19.564,19.564,0,1,0,238.535,175.7a33.2,33.2,0,0,0,7.149.927",
						transform: "translate(-38.095 -28.446)",
						fill: "#8b6adf"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_535",
						"data-name": "Path 535",
						d: "M240.122,177.053a19.564,19.564,0,1,1-31.263-23.486c5.747,7.729,16.853,20.036,31.263,23.486",
						transform: "translate(-39.682 -29.798)",
						fill: "#ffd100"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_536",
						"data-name": "Path 536",
						d: "M244.692,164.116A19.379,19.379,0,0,1,241.17,175.3c-14.411-3.449-25.517-15.757-31.263-23.486a19.566,19.566,0,0,1,34.785,12.3",
						transform: "translate(-40.73 -28.048)",
						fill: "#ffea85"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_537",
						"data-name": "Path 537",
						d: "M244.263,127.193c-6.19.04-13.081.081-19.835.129-.492-4.779-.911-8.608-1.2-11.235.943,0,1.894.008,2.869.016,1.282.016,2.547.032,3.8.064.161,0,.33.008.492.016q2.793.06,5.448.185c1.87.081,3.683.185,5.448.3a92.827,92.827,0,0,1,2.982,10.526",
						transform: "translate(-43.315 -22.525)",
						fill: "#daebf7"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_538",
						"data-name": "Path 538",
						d: "M255.275,309.68H234.819c.435-11.767.363-24.928-.032-38.573h20.52c.266,22.454-.032,38.573-.032,38.573",
						transform: "translate(-45.558 -52.605)",
						fill: "#b498fa"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_539",
						"data-name": "Path 539",
						d: "M251.128,169.716a29.563,29.563,0,0,0-19.649-28.95,36.343,36.343,0,0,0-17.272-1.628,26.188,26.188,0,0,1,36.921,30.578",
						transform: "translate(-41.565 -26.459)",
						fill: "#b498fa"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_540",
						"data-name": "Path 540",
						d: "M131.146,294.653l8.14,27.6,4.382-14.584,11.6-3.338-.69-25.862Z",
						transform: "translate(-25.448 -54.033)",
						fill: "#90b9d6"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_541",
						"data-name": "Path 541",
						d: "M297.358,290.54l17.911,12.2,13.18,57.109h-4.264L309.206,310.01,297.358,306.6Z",
						transform: "translate(-57.699 -56.376)",
						fill: "#90b9d6"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_542",
						"data-name": "Path 542",
						d: "M19.136,391.118h4.326v-5.77H13.628a2.057,2.057,0,0,1,0-4.114h9.834V338.572H16.428a3.68,3.68,0,0,1,0-7.361h18.1a3.68,3.68,0,0,1,0,7.361H27.38v42.663H38.53a2.057,2.057,0,0,1,0,4.114H27.38v5.77h4.267a7.565,7.565,0,0,1,7.566,7.565H11.571a7.564,7.564,0,0,1,7.565-7.565",
						transform: "translate(-2.245 -64.268)",
						fill: "#a67cf4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_543",
						"data-name": "Path 543",
						d: "M30.6,397.845l-.818,2.4a2.689,2.689,0,0,1-2.556.869c-1.891-.153-2.3-.818-2.3-.818l.409-3.067Z",
						transform: "translate(-4.838 -77.079)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_544",
						"data-name": "Path 544",
						d: "M51.465,391.247l-1.961,3.2a10.127,10.127,0,0,1-3.042-.716,3.166,3.166,0,0,1-1.555-1.384l1.572-3.047Z",
						transform: "translate(-8.714 -75.541)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_545",
						"data-name": "Path 545",
						d: "M49.267,394.545a33.6,33.6,0,0,0,2.857,5.938c1.254,1.666,1.717,2.075,1.591,2.838s-3.163.9-5.485-.767a14.053,14.053,0,0,1-3.653-3.788c-1.051-1.283-2.123-2.146-2.452-2.994s2.807-4.056,2.807-4.056.479,2.395,4.334,2.831",
						transform: "translate(-8.169 -76.008)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_546",
						"data-name": "Path 546",
						d: "M29.5,400.777a34.454,34.454,0,0,0,1.227,6.185c.869,2.606,1.687,3.885,1.278,5.009s-1.942,1.636-4.524.92-3.092-2.658-3.553-5.061a12.081,12.081,0,0,1-.46-3.169c.052-.409,1.176-4.7,1.176-4.7a5.294,5.294,0,0,0,4.856.818",
						transform: "translate(-4.551 -77.608)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_547",
						"data-name": "Path 547",
						d: "M57.252,352.732l-9.365,26.282a8.046,8.046,0,0,1-4.062-.991,11.618,11.618,0,0,1-2.893-2.071s3.192-21.656,6.3-25.549L35.217,333.711c1.62,6.552,3.28,14.7,2.99,19.746l-7.092,28.765c-1.386,1.523-3.433,1.5-5.118,1.1a12.174,12.174,0,0,1-2.918-1.1s4.255-28.547,4.272-28.579c-1.354-3.844-6.109-17.707-6.714-23.9.3-4.094,1.281-11.6,1.281-11.6l3.433-.016,17.763-.1.363,4.384.04-.032s8.962,12.347,13.371,22.293a11.054,11.054,0,0,1,.363,8.06",
						transform: "translate(-4.004 -61.71)",
						fill: "#2d2e83"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_548",
						"data-name": "Path 548",
						d: "M50.09,273.17a4.942,4.942,0,0,1,2.429,3.842l7.119,20.451-6.667,3.842s-3.842-7.232-4.407-12.542S50.09,273.17,50.09,273.17",
						transform: "translate(-9.405 -53.006)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_549",
						"data-name": "Path 549",
						d: "M36.668,269.745l8.023,2.486a53.792,53.792,0,0,1,1.017,9.548c0,4.689-1.636,13.842-1.636,13.842l-1,13.446L21.923,308.5s-2.074-29.745-.944-36.637l9.6-3.532Z",
						transform: "translate(-4.005 -52.067)",
						fill: "#daebf7"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_550",
						"data-name": "Path 550",
						d: "M32.91,264.513l.73-5.891c-.615-3.122-1.461-8.981.438-10.635,2.627-2.288,12.542-2.514,12.372,5.565,0,0-1.13,6.667-2.938,9.6-.728,1.182-2.4,1-4.137.36l-.976,4.131Z",
						transform: "translate(-6.386 -47.852)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_551",
						"data-name": "Path 551",
						d: "M45.977,252.248s-5.678.762-7.67-1.186a6.145,6.145,0,0,1-.593,3.559,2.267,2.267,0,0,1-1.992,1.229s0-2.161-.932-2.119-1.126,2.339-.668,3.669,1.092,1.331,1.092,1.331l-1.951.974a70.975,70.975,0,0,1-1.481-8.644,3.49,3.49,0,0,1,1.144-2.881,3.971,3.971,0,0,1,3.517-2.5c2.839-.3,6.187.89,8.982,2.373s3.136,2.924,2.924,3.221-.847.3-.847.3.471,2.831-1.544,3.217a7.917,7.917,0,0,0,.019-2.539",
						transform: "translate(-6.167 -47.663)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_552",
						"data-name": "Path 552",
						d: "M26,383.355a12.178,12.178,0,0,1-2.918-1.1s4.255-28.547,4.272-28.579c-1.354-3.844-6.109-17.707-6.714-23.9.3-4.094,1.281-11.6,1.281-11.6s3.466.056,3.482.089a30.493,30.493,0,0,0-.959,12.871c1.04,7,6.045,22.881,6.311,24.348C31,356.9,24.538,375.6,26,383.355",
						transform: "translate(-4.004 -61.739)",
						fill: "#20245f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_553",
						"data-name": "Path 553",
						d: "M40.034,266.717s-3.137-1.124-3.731-3.624c0,0,0,4.331,3.325,5.344Z",
						transform: "translate(-7.044 -51.05)",
						fill: "#ef8d70"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_554",
						"data-name": "Path 554",
						d: "M32.912,265.906l5.2,5.487-3.284,2.021-3.408-5.091Z",
						transform: "translate(-6.096 -51.596)",
						fill: "#ffefc9"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_555",
						"data-name": "Path 555",
						d: "M40.351,269.128l-.63,2.669,2.57.988-.253-3.279-1.385-1.523Z",
						transform: "translate(-7.707 -51.999)",
						fill: "#ffefc9"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_556",
						"data-name": "Path 556",
						d: "M20.1,272.714s2.3,1.61,3.317,6.13S24.661,300.2,24.661,300.2l-6.44,1.016S15.4,287.544,16.3,280.539s3.8-7.825,3.8-7.825",
						transform: "translate(-3.128 -52.917)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_557",
						"data-name": "Path 557",
						d: "M79.511,312.236a12.357,12.357,0,0,0-.531-1.4c-.23-.6-1.007-1.071-1.784-1.532s-4.98-.224-4.98-.224l-.1.094-11.391-5.862c-3.39-.226-6.667,3.842-6.667,3.842,1.631,1.722,11.467,3.951,15.3,4.767l2.137,1.809,4,1.266s.23-.749,0-1.094-2.073-1-2.39-1.448-.259-.827,1.5-.855,1.842.733,2.332,1.079.778,1.5,1.641,1.64l.863.144-.2-1.324a2.6,2.6,0,0,0,.272-.9",
						transform: "translate(-10.489 -58.852)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_558",
						"data-name": "Path 558",
						d: "M25.166,306.788l13.649,7.437-3.169,3.636s-12.353-3.615-14.75-5.536a5.57,5.57,0,0,1-2.17-4.52,12.4,12.4,0,0,1,6.44-1.017",
						transform: "translate(-3.632 -59.505)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_1204",
						"data-name": "Rectangle 1204",
						width: 82.125,
						height: 3.271,
						transform: "translate(17.231 258.355)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_559",
						"data-name": "Path 559",
						d: "M107.513,276.069l-6,26.129a1.792,1.792,0,0,1-1.741,1.394H58.366a1.789,1.789,0,0,1-1.749-2.168L62.186,275.3a1.735,1.735,0,0,1,.935-1.209v-.008a1.8,1.8,0,0,1,.822-.2h41.821a1.793,1.793,0,0,1,1.749,2.192",
						transform: "translate(-10.978 -53.143)",
						fill: "#a67cf4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_560",
						"data-name": "Path 560",
						d: "M98.5,303.643H58.366a1.789,1.789,0,0,1-1.749-2.168l5.569-26.129a1.735,1.735,0,0,1,.935-1.209c.193.331,11.678,20.7,35.382,29.506",
						transform: "translate(-10.978 -53.193)",
						fill: "#8c6cdc"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_561",
						"data-name": "Path 561",
						d: "M91.6,295.187l3.953,20.446H75.245L75.927,314h8.178l-2.726-18.81Z",
						transform: "translate(-14.601 -57.278)",
						fill: "#5353ce"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_562",
						"data-name": "Path 562",
						d: "M41.925,316.1l7.486-.593,3.192,2.373.423,1.695h-13.3s.721-2.585,2.2-3.474",
						transform: "translate(-7.707 -61.221)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_563",
						"data-name": "Path 563",
						d: "M105.713,324.615,96.921,397.4H70.342l9.813-72.788Z",
						transform: "translate(-13.649 -62.988)",
						fill: "#daebf7"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_564",
						"data-name": "Path 564",
						d: "M106.7,331.2,79.523,342.517l2.414-17.9h25.558Z",
						transform: "translate(-15.431 -62.988)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_565",
						"data-name": "Path 565",
						d: "M53.981,352.384A180.553,180.553,0,0,0,48.8,370.857a96.372,96.372,0,0,0-1.6,9.962,11.621,11.621,0,0,1-2.893-2.072s3.192-21.656,6.3-25.549L38.587,336.507l-.58-4.07Z",
						transform: "translate(-7.375 -64.506)",
						fill: "#20245f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_566",
						"data-name": "Path 566",
						d: "M223.547,91.467A236.477,236.477,0,0,0,294.439,115.7s-33.277-22.91-70.892-24.235",
						transform: "translate(-43.377 -17.748)",
						fill: "#4141ae"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_567",
						"data-name": "Path 567",
						d: "M312.966,189.774l-.043,4.015s-5.527,2.764-7.125,3.454-1.942,1.77-.82,2.158,15.07.5,15.285,0c.561-1.3-1.468-5.569-1.468-5.569l-.345-4.059Z",
						transform: "translate(-59.05 -36.824)",
						fill: "#2d2e83"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_568",
						"data-name": "Path 568",
						d: "M351.92,188.066l2.13,3.454s-2.594,3.793-3.857,4.605c-.753.484-2.706.748-3.224,1.554s0,1.415,3.281,1.456,4.145-.017,6.045-1.341,5.527-4.605,5.469-5.526-2.648-3.094-2.648-3.094l-1.094-2.49Z",
						transform: "translate(-67.292 -36.224)",
						fill: "#2d2e83"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_569",
						"data-name": "Path 569",
						d: "M332.933,114.877s-.518,16.753,2.936,28.842,12.78,31.259,12.78,31.259l9.672-2.763s-6.908-25.043-11.571-31.6c0,0-1.727-27.979-3.627-31.778s-10.19,6.045-10.19,6.045",
						transform: "translate(-64.597 -20.948)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_570",
						"data-name": "Path 570",
						d: "M302.666,35.091c3.836-3.705,11.447-2.678,12.621,1.738a17.235,17.235,0,0,1-.416,10.536l1.914,4.991L311.7,56.48,309.642,52.7a8.822,8.822,0,0,1-3.184.837c-2.565.132-4.38-3.4-5.431-9.562s1.638-8.88,1.638-8.88",
						transform: "translate(-58.364 -6.37)",
						fill: "#ffa07e"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_571",
						"data-name": "Path 571",
						d: "M294.339,103.991a270.658,270.658,0,0,0-25.557-10.8q-4.4-1.608-9.228-3.2A182.846,182.846,0,0,0,226.4,82.149c2.466-3.006,5-5.867,7.592-8.535,11.872-12.234,25.033-20.52,39.121-21.237.8.621,1.572,1.273,2.321,1.95a40.032,40.032,0,0,1,3.587,3.715c9.526,11.1,13.967,27.58,15.321,45.948",
						transform: "translate(-43.93 -10.163)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_572",
						"data-name": "Path 572",
						d: "M279.438,94.357c10.421-10.469,7.987-31.2,6.649-38.863,12.017,10.929,17.393,29.119,18.908,49.663a270.677,270.677,0,0,0-25.557-10.8",
						transform: "translate(-54.222 -10.768)",
						fill: "#90b9d6"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_573",
						"data-name": "Path 573",
						d: "M328.032,61.543s8.27,9.724,9.534,26.368l-16.876,6.4s-10.648-17.464-11.81-23.676,2.346-12.691,2.346-12.691l6.273-4.17s7.979,3.557,10.532,7.765",
						transform: "translate(-59.889 -10.435)",
						fill: "#a67cf4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_574",
						"data-name": "Path 574",
						d: "M315.5,63.193a4.541,4.541,0,0,1,.634,6.421c-3.337,4.025-8.845,10.472-12.64,13.9-5.782,5.219-25.966-.9-25.966-.9l.959-5.294,20.684-.1,9.814-13.2a4.543,4.543,0,0,1,6.514-.815",
						transform: "translate(-53.851 -12.064)",
						fill: "#5353cd"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_575",
						"data-name": "Path 575",
						d: "M300.573,38.419a5.954,5.954,0,0,1,2.03-5.468,8.774,8.774,0,0,1,8.243-1.368,10.552,10.552,0,0,1,2.188,1.016,2.438,2.438,0,0,1,1.171-2.3c1.406-.977,4.336.976,4.571,3.359a2.067,2.067,0,0,1-2.045,2.422,16.6,16.6,0,0,1,0,5.313,14.651,14.651,0,0,1-1.915,5.437,7.787,7.787,0,0,1-2.6-2.312s1.835-2.578,1.211-4.336-2.578-1.055-2.812.625l-.235,1.68-1.132-.274a10.806,10.806,0,0,1-.514-4.687s-7.612,2.266-8.157.9",
						transform: "translate(-58.309 -5.828)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_576",
						"data-name": "Path 576",
						d: "M303.756,56.4c2.07,1.016,4.984.547,6.145-1.289s.77-8.36.77-8.36l-1.211-.546-1.25,3.281s-5.061-.825-6.4-.08c0,0-.126,5.979,1.945,6.994",
						transform: "translate(-58.563 -8.966)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_577",
						"data-name": "Path 577",
						d: "M318.01,52.31l-6.162,5.354,1.11,3.238,7.124-6.438Z",
						transform: "translate(-60.511 -10.15)",
						fill: "#5353cd"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_578",
						"data-name": "Path 578",
						d: "M276.742,80.486l-1.718-.22s-3.57-1.382-4.692-1.67-1.439.364-1.237.945a1.471,1.471,0,0,0-.26,1.5,1.117,1.117,0,0,0-.106,1.352,1.5,1.5,0,0,0,.229,1.252,3.3,3.3,0,0,0,1.705.863,2.02,2.02,0,0,0,.712,0,4.264,4.264,0,0,0,1.813.562,3.927,3.927,0,0,0,1.511-.3l1.211.3Z",
						transform: "translate(-52.108 -15.237)",
						fill: "#ffa07e"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_579",
						"data-name": "Path 579",
						d: "M340.466,96.13l.849,2.635-16.579,6.39-1.145-2.621Z",
						transform: "translate(-62.789 -18.653)",
						fill: "#5353cd"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_580",
						"data-name": "Path 580",
						d: "M338.091,99.4l-16.579,6.39-13.259,28.236a13.463,13.463,0,0,0-1.168,7.424l4.064,31.868h9.217a112.377,112.377,0,0,0,.8-18.652,51.359,51.359,0,0,0-2.677-15.1c1.06-1.344,17.1-21.716,19.6-27.56,2.59-6.045,0-12.608,0-12.608",
						transform: "translate(-59.566 -19.287)",
						fill: "#daebf7"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_581",
						"data-name": "Path 581",
						d: "M416,374.672h5.526L344.265,204.6h8.981v-3.31H283.933v3.31h10.822l16.122,36.081v.173h.077l9.02,20.189v.406h.182l8.916,19.956v.639h.285l8.812,19.723v.872h.39l8.708,19.491v1.1h.494l8.6,19.257v1.338h.6l8.5,19.024v1.572h.7l4.579,10.247h5.526l-4.654-10.247h39.8ZM354.724,237.544H313.981l-7.853-17.285H347ZM340.005,204.6l5.517,12.349h-40.9L299.016,204.6Zm16.2,36.254,7.724,17.285H323.336l-7.852-17.285Zm9.2,20.595,7.724,17.285H332.692l-7.852-17.285Zm9.2,20.6,7.723,17.285H342.048L334.2,282.045Zm9.2,20.595,7.724,17.285H351.4l-7.852-17.285Zm9.2,20.6,7.723,17.285H360.759l-7.852-17.285Zm-22.9,37.88-7.852-17.285h39.952l7.723,17.285Z",
						transform: "translate(-55.094 -39.058)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_582",
						"data-name": "Path 582",
						d: "M294.439,110.52v4.392s-17.094-10.284-34.624-15.966a244.091,244.091,0,0,0-36.268-8.269l1.531-2.184.766-1.088s14.362-.556,35.777,7.028,32.819,16.087,32.819,16.087",
						transform: "translate(-43.377 -16.958)",
						fill: "#a67cf4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_583",
						"data-name": "Path 583",
						d: "M280.846,58.043a17.927,17.927,0,0,0-13.991-1.693c-9.43,2.418-23.542,11.9-31.038,17.264,11.872-12.234,25.033-20.52,39.121-21.237.8.621,1.572,1.273,2.321,1.95a40.024,40.024,0,0,1,3.587,3.715",
						transform: "translate(-45.758 -10.163)",
						fill: "#daebf7"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_584",
						"data-name": "Path 584",
						d: "M294.439,110.784v4.392s-17.094-10.284-34.624-15.966a244.092,244.092,0,0,0-36.268-8.269l1.531-2.184c3.167,0,11.251.54,24.324,4.892,17.288,5.755,41.467,16.885,45.037,17.135",
						transform: "translate(-43.377 -17.222)",
						fill: "#8b6adf"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_1205",
						"data-name": "Rectangle 1205",
						width: 33.633,
						height: 68.152,
						transform: "translate(225.006 198.578)",
						fill: "#6ceada"
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_448",
						"data-name": "Line 448",
						x2: 26.344,
						transform: "translate(228.839 203.307)",
						fill: "none",
						stroke: "#5353cd",
						strokeMiterlimit: 10,
						strokeWidth: .5
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_585",
						"data-name": "Path 585",
						d: "M312.81,314.539H279.177V246.387s9.776,51.2,33.633,68.152",
						transform: "translate(-54.171 -47.809)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_449",
						"data-name": "Line 449",
						x2: 25.999,
						transform: "translate(229.184 205.955)",
						fill: "none",
						stroke: "#5353cd",
						strokeMiterlimit: 10,
						strokeWidth: .5
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_450",
						"data-name": "Line 450",
						x2: 26.344,
						transform: "translate(228.839 254.726)",
						fill: "none",
						stroke: "#5353cd",
						strokeMiterlimit: 10,
						strokeWidth: .5
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_451",
						"data-name": "Line 451",
						x2: 25.999,
						transform: "translate(229.184 257.374)",
						fill: "none",
						stroke: "#5353cd",
						strokeMiterlimit: 10,
						strokeWidth: .5
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_452",
						"data-name": "Line 452",
						x2: 26.344,
						transform: "translate(228.839 260.271)",
						fill: "none",
						stroke: "#5353cd",
						strokeMiterlimit: 10,
						strokeWidth: .5
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_453",
						"data-name": "Line 453",
						x2: 25.999,
						transform: "translate(229.184 262.919)",
						fill: "none",
						stroke: "#5353cd",
						strokeMiterlimit: 10,
						strokeWidth: .5
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_586",
						"data-name": "Path 586",
						d: "M303.448,271.834c-.806-6.563-7.254-10.823-7.254-10.823s-6.448,4.26-7.254,10.823,3.627,22.922,3.627,22.922h7.254S304.254,278.4,303.448,271.834Z",
						transform: "translate(-56.047 -50.646)",
						fill: "none",
						stroke: "#fff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: .5,
						strokeDasharray: "1 1"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_587",
						"data-name": "Path 587",
						d: "M289.735,292.851s-3.67,2.628-4.62,3.578-.95,6.045-.95,6.045l2.548-3.973,4.219-.42",
						transform: "translate(-55.139 -56.825)",
						fill: "none",
						stroke: "#fff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: .5,
						strokeDasharray: "1 1"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_588",
						"data-name": "Path 588",
						d: "M304.59,292.851s3.67,2.628,4.62,3.578.95,6.045.95,6.045l-2.548-3.973-4.219-.42",
						transform: "translate(-58.87 -56.825)",
						fill: "none",
						stroke: "#fff",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: .5,
						strokeDasharray: "1 1"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_589",
						"data-name": "Path 589",
						d: "M301.38,277.854a4.188,4.188,0,1,1-4.188-4.188,4.188,4.188,0,0,1,4.188,4.188",
						transform: "translate(-56.854 -53.102)",
						fill: "#ffea85"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_1206",
						"data-name": "Rectangle 1206",
						width: 8.637,
						height: 2.72,
						transform: "translate(246.547 209.467)",
						fill: "#ffea85"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_590",
						"data-name": "Path 590",
						d: "M313.843,266.51a1.684,1.684,0,1,1-1.684-1.684,1.683,1.683,0,0,1,1.684,1.684",
						transform: "translate(-60.244 -51.387)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_591",
						"data-name": "Path 591",
						d: "M340.317,299.87s1.839,1.508,1.235,9.539-3.195,8.635-6.3,8.118Z",
						transform: "translate(-65.051 -58.187)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_592",
						"data-name": "Path 592",
						d: "M329.226,286.573l-1.048,5.843L322,293.778l.29-4.231c-1.427.073-2.732-.1-3.409-.8a1.734,1.734,0,0,1-.427-.774c-.854-3.345.048-10.05.048-10.05,2.241-7.761,10.228-4.892,12.057-1.926,1.322,2.144.177,7.777-1.338,10.574",
						transform: "translate(-61.722 -52.959)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_593",
						"data-name": "Path 593",
						d: "M322.486,292.91c-1.427.073-2.732-.1-3.409-.8.79-.073,2.95-.371,3.965-1.628.911-1.128-.556,2.426-.556,2.426",
						transform: "translate(-61.913 -56.322)",
						fill: "#ef8f75"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_594",
						"data-name": "Path 594",
						d: "M332.84,284.86c-.1.2-.2.4-.314.6-2.031,3.587-5.311,3.627-7.947,2.635s-2.289-2.6-2.289-2.6.733.395,1.467-.685a4.281,4.281,0,0,0,.516-2.684c-.089-.588-.339-1.04-.774-1.072a.846.846,0,0,0-.322.032c-.822.193-1.1,1.386-1.1,1.386a2.026,2.026,0,0,1-.258-1.684c-2.329-.685-2.458-2.112-2.458-2.112l-.218,1.032A3.286,3.286,0,0,1,317.2,275.4a4.534,4.534,0,0,1,2.6-2.8.647.647,0,0,1,.073-.032c1.556-1.024,6.827-2.474,10.018-.79s2.893,4.36,2.893,4.36c1.676,1.717,1.765,5.311.056,8.729",
						transform: "translate(-61.507 -52.585)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_595",
						"data-name": "Path 595",
						d: "M340.5,276.819c-.016.065-.024.129-.04.185a2.575,2.575,0,0,1-3.159,2.12c-.008,0-.008,0-.016-.008a3.616,3.616,0,0,1-1.273-.524,4.489,4.489,0,0,1-.919-.814,5.893,5.893,0,0,1-.9-1.523,1.689,1.689,0,0,1-.089-.234,5.488,5.488,0,0,1-.25-.838,5.273,5.273,0,0,1-.024-.669.2.2,0,0,1,0-.1,2.19,2.19,0,0,1,.008-.226v-.008a2.841,2.841,0,0,1,2.386-2.934c2.853-.387,4.755,3.063,4.28,5.569",
						transform: "translate(-64.774 -52.627)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_596",
						"data-name": "Path 596",
						d: "M333.078,323.945l.008.6a22.994,22.994,0,0,1-8.543,1.088,47.933,47.933,0,0,1-5.384-.629c-2.434-.427-4.119-.887-4.119-.887l1.153-6.085-.484-4.336c-1.177-.927-2.764-2.41-3.087-3.9-.331-1.547.758-6.254,1.58-9.446l-.314-2.781c.363-.113.75-.226,1.161-.331.073-.016.153-.04.226-.056a108.258,108.258,0,0,1,11.59-1.95c3.893.427,9.051,3.732,9.051,3.732-.274,2.692-3.014,14.475-3.014,14.475l.1,5.73Z",
						transform: "translate(-60.649 -57.288)",
						fill: "#a67cf4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_597",
						"data-name": "Path 597",
						d: "M333.078,324.415l-13.919,1.064c-2.434-.427-4.119-.887-4.119-.887l1.153-6.085-.484-4.336c-1.177-.927-2.764-2.41-3.087-3.9-.331-1.547.758-6.254,1.58-9.446l-.314-2.781c.363-.113.75-.226,1.161-.33.073-.016.153-.04.226-.056.427,3.74,2.273,16.683,5.972,19.577,3.353,2.627,9.325,2.563,11.751,2.41Z",
						transform: "translate(-60.649 -57.757)",
						fill: "#8261d5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_598",
						"data-name": "Path 598",
						d: "M307.226,296.3l-11.975,8.172L283.964,294.1l.018-.018s-.625-2.374-.82-2.893a5.513,5.513,0,0,0-1.618-1.943c-.324-.065-.238.367-.13.648s.475,1.425.475,1.425l-2.224-1.123s-.539-1.49-.907-1.533-.259,1.4.108,2.008a.967.967,0,0,0-.335.993.955.955,0,0,0-.161,1.036s-.583.583.475,1.748a17.16,17.16,0,0,0,2.526,2.183c1.3,1.875,8.873,12.618,13.364,13.879,4.922,1.381,12-4.116,12-4.116s5.124-4.11.49-10.1",
						transform: "translate(-53.984 -56.013)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_599",
						"data-name": "Path 599",
						d: "M327.765,421.607c-.637.113-13.355.29-13.588-.347s-.459-1.209,2.3-2.071a9.135,9.135,0,0,0,1.8-.838,26.244,26.244,0,0,0,4.038-3.127l-2.49-13.081-.58-3.047h7.592a22.819,22.819,0,0,1,.379,3.651c.226,4.392.209,11.034.2,12.815,0,0,.113.685.234,1.6.242,1.765.532,4.376.113,4.449",
						transform: "translate(-60.938 -77.441)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_600",
						"data-name": "Path 600",
						d: "M352.059,421.143c-.54.346-9.059.1-11.421.024a.456.456,0,0,1-.363-.717,8.2,8.2,0,0,1,2.458-1.781,3.76,3.76,0,0,0,.838-.653,15.618,15.618,0,0,0,2.305-3.208L342.9,402.033H342.9l-.822-3.546,7.084.862a18.223,18.223,0,0,1,.645,3.3c.532,4.038.862,10.058.967,11.928l.024.008s.25.806.532,1.846c.508,1.846,1.137,4.457.734,4.715",
						transform: "translate(-66.01 -77.322)",
						fill: "#ffb896"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_601",
						"data-name": "Path 601",
						d: "M328.468,402.748a29.948,29.948,0,0,1-7.391-.6l-.58-3.047h7.592a22.828,22.828,0,0,1,.379,3.651",
						transform: "translate(-62.189 -77.441)",
						fill: "#ef8f75"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_602",
						"data-name": "Path 602",
						d: "M350.256,402.646a30.422,30.422,0,0,1-6.9-.612h-.008l-.822-3.546,7.084.862a18.213,18.213,0,0,1,.645,3.3",
						transform: "translate(-66.464 -77.322)",
						fill: "#ef8f75"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_603",
						"data-name": "Path 603",
						d: "M345.479,400.3a13.673,13.673,0,0,1-5.384,1.624,15.977,15.977,0,0,1-5.15-.347L326.1,353.248l1.91,47.347a9.606,9.606,0,0,1-6.166,1.655.072.072,0,0,1-.065,0,20.28,20.28,0,0,1-3.417-.358c-.774-.143-1.249-.276-1.249-.276s-7.423-39.177-6.214-52.964,3.8-17.525,3.8-17.525a45.36,45.36,0,0,1,9.913-2.186,27.982,27.982,0,0,1,8.1.133c5.835,8.1,5.65,20.017,5.65,20.017Z",
						transform: "translate(-60.3 -63.788)",
						fill: "#2d2e83"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_604",
						"data-name": "Path 604",
						d: "M327.77,425.836c-.637.113-13.355.29-13.589-.346s-.459-1.209,2.305-2.071a9.138,9.138,0,0,0,1.8-.838c-.008.21.1.443.621.459.951.032,2.765-.484,5.464-1.644,2.6-1.1,3.24-.089,3.288-.008.242,1.765.532,4.376.113,4.449",
						transform: "translate(-60.939 -81.668)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_605",
						"data-name": "Path 605",
						d: "M352.064,425.309c-.54.347-9.059.1-11.421.024a.456.456,0,0,1-.363-.717,8.2,8.2,0,0,1,2.458-1.781,3.76,3.76,0,0,0,.838-.653,2.16,2.16,0,0,0,1.209.016c1.547-.282,2.1-2.241,4.457-2.241a2.775,2.775,0,0,1,2.087.637c.508,1.846,1.136,4.457.734,4.715",
						transform: "translate(-66.011 -81.488)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_606",
						"data-name": "Path 606",
						d: "M343.786,390a20.1,20.1,0,0,1-5.15-.274l-8.849-38.138,6.335-4.763s-.669,12.782,1.281,22.913A115.641,115.641,0,0,0,343.786,390",
						transform: "translate(-63.992 -67.298)",
						fill: "#20245f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_607",
						"data-name": "Path 607",
						d: "M315.86,346.87c-1.6,16.208,5.8,39.379,5.98,39.919v.008l-.065-.008-3.417-.282c-.774-.113-1.249-.218-1.249-.218s-7.423-30.917-6.214-41.8,3.8-13.83,3.8-13.83a55.955,55.955,0,0,1,9.913-1.725c-2.539,1.451-7.552,5.811-8.745,17.933",
						transform: "translate(-60.3 -63.827)",
						fill: "#20245f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_608",
						"data-name": "Path 608",
						d: "M299.14,308.853l-1.227,3.047s-.974-2.709,1.227-3.047",
						transform: "translate(-57.765 -59.93)",
						fill: "#ef8f75"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_609",
						"data-name": "Path 609",
						d: "M324.012,316.053h10.38s.149,1.775-4.342,1.775-6.038-1.775-6.038-1.775",
						transform: "translate(-62.871 -61.327)",
						fill: "#8261d5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_610",
						"data-name": "Path 610",
						d: "M322.072,282.858a2.026,2.026,0,0,1-.258-1.684c-2.329-.685-2.458-2.112-2.458-2.112l-.218,1.032a3.286,3.286,0,0,1-1.942-4.312,4.534,4.534,0,0,1,2.6-2.8c.137,1.451.726,5.585,3.377,8.495-.822.193-1.1,1.386-1.1,1.386",
						transform: "translate(-61.507 -52.968)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_611",
						"data-name": "Path 611",
						d: "M334.113,287.539c-.1.2-.2.4-.314.6-2.031,3.586-5.311,3.627-7.947,2.635s-2.289-2.6-2.289-2.6.733.4,1.467-.685a4.281,4.281,0,0,0,.516-2.684,8.821,8.821,0,0,0,2.748,1.491,20.372,20.372,0,0,0,5.819,1.241",
						transform: "translate(-62.781 -55.264)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_612",
						"data-name": "Path 612",
						d: "M340.458,277.71a2.575,2.575,0,0,1-3.159,2.12c-.008,0-.008,0-.016-.008a4.528,4.528,0,0,1-2.192-1.338,4.632,4.632,0,0,1-.9-1.523,1.705,1.705,0,0,1-.089-.234,6.125,6.125,0,0,1-.274-1.507.2.2,0,0,1,0-.1,1.652,1.652,0,0,1-.008-.266c.008.008.008.024.016.032v.008c1.2,2.668,5.053,2.853,6.625,2.813",
						transform: "translate(-64.773 -53.333)"
					})
				]
			})
		})
	})
});
export default SvgRocket;
